import styled from '@emotion/styled';
import { Box, Typography } from '@mui/material';

const Container = styled(Box)`
  width: 100%;
  position: relative;
  background-color: #8b92a3;
  height: 1px;
`;

const RulerItem = styled(Box)`
  position: absolute;
  top: 0;
`;

const DividerLine = styled(Box)(({ big }: { big: string }) => ({
  width: '1px',
  backgroundColor: '#8b92a3',
  height: big === 'true' ? '20px' : '10px',
}));

const Label = styled(Typography)`
  position: absolute;
  top: 0;
  color: #9197a7;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  display: block;
  transform: translate(-45%, 100%);
`;

export const getLeftOffSet = (index: number, total: number): string => `${index * (100 / total)}%`;

type Props = {
  interval: number;
  size: number;
};

export const BarGraphRuler = ({ interval = 5, size = 10 }: Props) => {
  const lines = [];

  for (let i = 0; i <= size; i++) {
    const isInterval = i % interval === 0;

    lines.push(
      <RulerItem key={i} sx={{ left: getLeftOffSet(i, size) }}>
        <DividerLine big={isInterval.toString()} />
        {isInterval && <Label>{i}</Label>}
      </RulerItem>
    );
  }

  return <Container>{lines}</Container>;
};
